<template>
    <div class="multiple-select">
        <v-popconfirm
            ref="pop"
            :clazz="['multiple-select-pop', clazz]"
            :fixed="false"
            :priority="['bottom', 'top']"
            :inline="inline"
            :use-arrow="false"
            :use-close="close"
            :confirm-disabled="canConfirm"
            @confirm="handleConfirm"
            @cancel="handleCancel"
            @visibleChange="visibleChange($event)"
        >
            <h3
                v-if="title"
                class="multiple-select-panel-header"
            >
                <slot name="header">
                    {{ title }}
                </slot>
            </h3>
            <v-checkbox-group
                v-if="selectType === 'checkbox'"
                class="options-list"
                :value="selectedValue"
                @change="handleGroupChange"
            >
                <div
                    v-for="(op, index) in options"
                    :key="index"
                    class="list-item"
                >
                    <v-checkbox
                        v-if="typeof op === 'object'"
                        :value="op[map.value]"
                    >
                        {{ op[map.text] }}
                    </v-checkbox>
                    <v-checkbox
                        v-else
                        :key="index"
                        :value="op"
                    />
                </div>
            </v-checkbox-group>
            <div
                v-if="selectType === 'tree'"
                class="multiple-select__tree"
            >
                <v-tree
                    ref="tree"
                    :value="selectedValue"
                    :options="options"
                    :single="false"
                    :with-checkbox="true"
                    :single-expand="false"
                    :maps="{ value: 'value' }"
                    :only-folder-id="true"
                    @input="handleGroupChange"
                >
                    <template
                        slot="label"
                        slot-scope="props"
                    >
                        {{ props.options.text }}
                    </template>
                </v-tree>
            </div>
            <slot
                name="specific-action"
                :options="options"
            />
            <span
                slot="confirm-text"
            >{{ confirmText }}{{ showSelectNum && selectedValue.length ? `(${selectedValue.length})` : '' }}</span>
            <span
                v-if="selectAll"
                class="select-btn"
                @click="handleSelectAll"
            >全选</span>
            <span
                v-if="clearAll"
                class="select-btn clear-all-btn"
                @click="handleClearAll"
            >清空</span>
        </v-popconfirm>
        <div
            v-popconfirm:pop
            :class="[
                'multiple-select-trigger',
                { 'is-placeholder': options.length === 0 || currentValue.length === 0, 'trigger-invalid': !valid }
            ]"
        >
            <slot
                name="info"
                :current="current"
            >
                <span
                    class="multiple-select-trigger-text"
                    :title="currentText"
                >{{ currentText }}</span>
            </slot>
            <v-icon
                :class="['multiple-select-trigger-arrow', { 'is-hiddenArrow': !arrow }]"
                name="arrow_dropdown"
            />
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'MultipleSelect',
    props: {
         valid:{
            type: Boolean,
            default: true
        },
        options: {
            type: Array,
            required: true
        },

        value: {
            type: Array,
            default: () => []
        },

        placeholder: {
            type: String,
            default: '请选择'
        },

        tagFormatter: {
            type: Function,
            default: null
        },

        title: {
            type: String,
            default: '标签'
        },

        selectType: {
            type: String,
            default: 'checkbox'
        },

        inline: {
            type: Boolean,
            default: false
        },

        group: {
            type: Boolean,
            default: false
        },

        close: {
            type: Boolean,
            default: true
        },

        arrow: {
            type: Boolean,
            default: true
        },

        confirmText: {
            type: String,
            default: '确定'
        },

        showSelectNum: {
            type: Boolean,
            default: false
        },

        clazz: {
            type: String,
            default: ''
        },

        map: {
            type: Object,
            default: () => {
                return {
                    text: 'text',
                    value: 'value',
                    groupValue: 'groupValue'
                };
            }
        },
        selectAll: {
            type: Boolean,
            default: false
        },
        clearAll: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            currentValue: [...this.value],
            selectedValue: [...this.value],
            groupValue: undefined,
            current: [],
            currentText: '',
        };
    },

    computed: {
        canConfirm() {
            return !this.selectedValue.length;
        }
    },

    watch: {
        value(val) {
            this.selectedValue = [...val];
            this.currentValue = [...val];
            this.getCurrentText();
        },
        options(){
            this.getCurrentText();
        }
    },

    created() {
        this.getCurrentText();
        // 检测是否需要互斥
        if (this.group && this.currentValue.length) {
            this.options.forEach(item => {
                if (item[this.map.value] === this.currentValue[0]) {
                    this.groupValue = item[this.map.groupValue];
                    return false;
                }
            });
        }
    },

    methods: {
        handleConfirm() {
            this.currentValue = [...this.selectedValue];
             if (this.selectType === 'tree') {
                this.$emit('input', this.selectedValue, this.$refs.tree.getSelectedTree(false));
            } else {
               this.$emit('input', this.selectedValue);
            }
            
            this.$emit('confirm', this.selectedValue, this.current);
        },

        visibleChange(e) {
            this.$emit('visibleChange', e);
        },

        handleCancel() {
            if (this.currentValue.length) {
                this.selectedValue = this.currentValue;
                this.options.forEach(item => {
                    if (item[this.map.value] === this.currentValue[0]) {
                        this.groupValue = item[this.map.groupValue];
                    }
                });
            } else {
                this.selectedValue = [];
                this.groupValue = undefined;
            }
            this.$emit('cancel');
        },
        handleSelectAll() {
            this.options.forEach(item => {
                const index = ~this.selectedValue.indexOf(item[this.map.value]);
                !index && this.selectedValue.push(item[this.map.value]);
            });
        },
        handleClearAll() {
            this.selectedValue = [];
        },

        handleGroupChange(curSelectArr) {
            if (this.selectType === 'tree') {
                this.$emit('change', curSelectArr, this.$refs.tree.getSelectedTree(false));
            } else {
                this.$emit('change', curSelectArr);
            }
            

            if (this.selectAll) {
                this.groupValue = undefined;
                this.selectedValue = curSelectArr;

                return;
            }

            if (this.group) {
                    const lastSelect = curSelectArr[curSelectArr.length - 1];
                    // 空的新增一个
                    if (typeof this.groupValue === 'undefined') {
                        this.options.forEach(item => {
                            if (item[this.map.value] === lastSelect) {
                                if (item[this.map.groupValue] !== this.groupValue) {
                                    this.selectedValue = curSelectArr;
                                    this.groupValue = item[this.map.groupValue];
                                }
                            }
                        });
                        // 已有减去一个为空
                    } else if (!curSelectArr.length) {
                        this.selectedValue = curSelectArr;
                        this.groupValue = undefined;
                    } else {
                        this.options.forEach(item => {
                            if (item[this.map.value] === lastSelect) {
                                if (item[this.map.groupValue] !== this.groupValue) {
                                    this.selectedValue = [lastSelect];
                                    this.groupValue = item[this.map.groupValue];
                                } else {
                                    this.selectedValue = curSelectArr;
                                }
                            }
                        });
                    }
            } else {
                this.selectedValue = curSelectArr;
            }
        },

        getCurrent() {
            let result = []
            if(this.selectType === 'checkbox'){
                result = this.options.filter(op => this.currentValue.indexOf(op[this.map.value]) !== -1);
            }
            if(this.selectType === 'tree'){
                result = this.getTreeCurrentText(this.options, new Set(this.selectedValue));
            }
            return result;
        },

        getCurrentText() {
            this.current = this.getCurrent();
            if (this.options.length === 0 || this.currentValue.length === 0) {
                this.currentText = this.placeholder;
            }else{
                if(this.tagFormatter) {
                    let data = this.current;
                     if (this.selectType === 'tree') {
                        setTimeout(()=>{
                            data = this.$refs.tree && this.$refs.tree.getSelectedTree(false);
                            this.currentText = this.tagFormatter(data);
                        })
                        
                    }else {
                        this.currentText = this.tagFormatter(data);
                    }
                    
                    
                }else {
                    this.currentText = this.current.map(op => op[this.map.text]).join(', ');
                }
                
            }
        },

        getTreeCurrentText(originOptions, selected) {
            let options = [];
            originOptions.forEach(item => {
                if (item.children) {
                    options = options.concat(this.getTreeCurrentText(item.children, selected))
                }else if (selected.has(item.value)) {
                    options.push({
                        text: item.text,
                        value: item.value
                    });
                }
            });
            return options;
        }
    }
};
</script>

<style lang="less">
@import '~@/common/common';

.multiple-select {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    color: #1e2330;

    .multiple-select-trigger {
        cursor: pointer;
        color: currentColor;

        &-arrow {
            margin-left: 5px;
            width: 10px;
            height: 10px;
            color: currentColor;
            cursor: pointer;
        }
        // 直接display: none在有些情况下回出现莫名其妙的问题，未能找到原因
        .is-hiddenArrow {
            margin: 0;
            width: 0;
            height: 0;
        }

        &.is-placeholder {
            color: #a8abb3;
        }
    }

    &__tree{
        overflow-y: auto;
        height: 320px;
    }
}

.multiple-select-pop {
    margin-top: -5px;
    padding: 10px 20px 20px 10px;
    min-width: 280px;

    .options-list {
        padding-left: 10px;

        .list-item {
            padding: 8px 0;
        }
    }

    .select-btn {
        position: absolute;
        bottom: 28px;
        left: 20px;
        display: inline-block;
        color: @mainBlue;
        line-height: 14px;

        &:hover {
            color: @deepBlue;
            cursor: pointer;
        }
    }

    .clear-all-btn {
        margin-left: 40px;
    }

    .multiple-select-panel-header {
        padding-bottom: 20px;
    }
}
</style>
